import { siteStats, heroLead, heroSmall, hotChips, tickerItems } from '@/mocks/home';

export default function HeroMosaic() {
  return (
    <section id="top" className="bg-background-50 border-b border-background-200">
      <div className="flex items-center gap-3 px-4 md:px-8 h-10 border-b border-background-200/70 bg-background-100/70">
        <span className="shrink-0 inline-flex items-center gap-1 text-xs font-medium text-background-50 bg-primary-500 px-2.5 py-1 rounded-full">
          <i className="ri-flashlight-fill" />
          热讯
        </span>
        <div className="flex-1 flex items-center gap-6 overflow-hidden">
          {tickerItems.map((item) => (
            <span key={item} className="text-xs text-foreground-700 whitespace-nowrap">
              {item}
            </span>
          ))}
        </div>
        <span className="hidden lg:inline text-xs text-foreground-500 shrink-0">每 10 分钟刷新</span>
      </div>

      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-6 md:py-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-6 md:mb-8">
          <div className="w-full">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-fire-line" />
              网红黑料汇总 · 一页吃全
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
              热门的瓜，先看标题再决定吃哪一口
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
              从今日速报到历史档案，按目录直达。<strong className="font-medium text-foreground-900">网红黑料档案</strong>、网红黑料名单与专题合集持续整理，配图克制、只讲重点，省去自己翻找的时间。
            </p>
          </div>

          <div className="grid grid-cols-3 gap-3 md:gap-4 w-full lg:w-auto lg:min-w-[420px]">
            {siteStats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200 bg-background-100/80 px-3 py-3 md:px-4 md:py-4">
                <p className="font-heading text-xl md:text-2xl font-black text-foreground-950 leading-none">
                  {stat.value}
                  <span className="ml-1 text-xs font-medium text-foreground-500">{stat.unit}</span>
                </p>
                <p className="mt-2 text-xs text-foreground-600 leading-snug">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          <article className="lg:col-span-7 group">
            <div className="relative w-full h-60 sm:h-72 md:h-80 rounded-lg overflow-hidden bg-background-200">
              <img
                src={heroLead.image}
                alt={`${heroLead.title} - 网红黑料档案焦点事件配图`}
                title={`${heroLead.codename} 网红黑料档案焦点事件`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <span className="absolute top-3 left-3 inline-flex items-center gap-1 text-xs font-medium text-background-50 bg-primary-500 px-2.5 py-1 rounded-full">
                <i className="ri-fire-fill" />
                今日焦点
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-background-100 mb-2">
                  <span className="font-medium">{heroLead.codename}</span>
                  <span className="text-background-300">|</span>
                  <span>{heroLead.updated} 更新</span>
                </div>
                <h3 className="font-heading text-lg md:text-2xl font-bold text-background-50 leading-snug">
                  {heroLead.title}
                </h3>
              </div>
            </div>

            <div className="mt-3 flex flex-col md:flex-row md:items-center gap-3">
              <p className="flex-1 text-sm text-foreground-700 leading-relaxed">{heroLead.summary}</p>
              <div className="flex items-center gap-4 shrink-0 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-line text-primary-600" />
                  热度 {heroLead.heat}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-chat-3-line text-secondary-700" />
                  {heroLead.comments} 条讨论
                </span>
              </div>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-3 md:gap-4">
            {heroSmall.map((item) => (
              <article key={item.title} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300 transition-colors cursor-pointer">
                <div className="w-24 h-20 md:w-28 md:h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={`${item.title} - 网红黑料汇总速览配图`}
                    title={`${item.codename} 网红黑料汇总`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col">
                  <span className="inline-flex self-start items-center text-[11px] font-medium text-accent-900 bg-accent-100 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                  <h3 className="mt-1.5 text-sm font-semibold text-foreground-950 leading-snug line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="mt-auto pt-2 flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className="truncate">{item.codename}</span>
                    <span className="inline-flex items-center gap-1 shrink-0">
                      <i className="ri-chat-3-line" />
                      {item.comments}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-5 md:mt-6 flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-500 mr-1">热搜标签</span>
          {hotChips.map((chip) => (
            <a
              key={chip.label}
              href="#archive"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-background-300 bg-background-50 text-xs text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              #{chip.label}
              <span className="text-foreground-400">{chip.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}